module.exports = __webpack_public_path__ + "static/media/water4.34ba21d0.svg";